// extracted by mini-css-extract-plugin
export default {"cls1":"IQStWYb7KT8q93YGqVNC","cls2":"sli5Jo23ZA7qmbU9XETA IQStWYb7KT8q93YGqVNC"};